import { useCitySelectedContext } from '@porterin/feature/src/contexts/city-context/CityContext';
import {
  CityServices,
  ImageEntity,
  TextSubtext,
} from '@porterin/feature/src/shared/cities/domain/entities/CitiesEntity';
import { sortCityServicesByName } from '@porterin/feature/src/shared/core/helpers/CommonVehicleHelper';
import { MODAL_CLOSE_TIMEOUT_ANIMATED } from '@porterin/feature/src/shared/modal/domain/entities/ModalEntities';
import NextImageV2 from '@porterin/feature/src/ui/components/NextImageV2';
import { updateUserCity } from '@porterin/utils/src/helpers/LocalStorage';
import React from 'react';
import ReactModal from 'react-modal';

import styles from '../styles/CitySelectorModal.module.scss';

const modalStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
  },
};

interface CitySelectorModalCmpProps {
  modalState: boolean;
  close_modal: () => void;
  city_selector_data: CityServices[];
  close_icon: ImageEntity;
  city_title_desc: TextSubtext;
}

function CitySelectorModalCmp({
  modalState,
  close_modal,
  city_selector_data,
  close_icon,
  city_title_desc,
}: Readonly<CitySelectorModalCmpProps>): React.ReactElement {
  const citySelectedContext = useCitySelectedContext();

  const cityClickHandler = (city: string, city_label: string): void => {
    citySelectedContext.set_city_selected(city.toLocaleLowerCase(), city_label);
    close_modal();
    updateUserCity(city);
  };

  return (
    <ReactModal
      isOpen={modalState}
      onRequestClose={close_modal}
      closeTimeoutMS={MODAL_CLOSE_TIMEOUT_ANIMATED}
      style={modalStyles}
      className={styles['city-picker-modal']}
      ariaHideApp={false}
      shouldCloseOnOverlayClick
    >
      <div className={styles['container']}>
        <div className={styles['header-container']}>
          <button
            type="button"
            aria-label="Close"
            className={styles['close-button']}
            onClick={close_modal}
          >
            <NextImageV2
              src={close_icon.path}
              height={24}
              width={24}
              quality={100}
              alt={close_icon.alt_text}
            />
          </button>
          <div className={styles['title']}>{city_title_desc.text}</div>
        </div>
        <div className={styles['cities-list-container']}>
          {sortCityServicesByName(city_selector_data).map(
            (city_data: CityServices) => (
              <button
                type="button"
                className={styles['city-container']}
                key={city_data.city_name}
                onClick={() =>
                  cityClickHandler(city_data.city_name, city_data.city_label)
                }
              >
                <div className={styles['city-image']}>
                  <NextImageV2
                    src={city_data.city_image.path}
                    height={80}
                    width={80}
                    quality={100}
                    alt={city_data.city_image.alt_text}
                  />
                </div>
                <div className={styles['city-title']}>
                  {city_data.city_name}
                </div>
              </button>
            ),
          )}
        </div>
      </div>
    </ReactModal>
  );
}

export default CitySelectorModalCmp;
